<template>
  <div>
    <!-- 导航 -->
    <van-nav-bar fixed placeholder  left-arrow :border="false" @click-left="$router.back()">
      <template #title>
        <div class="title-slot">
          <span>户籍人口分析</span>
          <van-dropdown-menu>
            <van-dropdown-item
              :options="pages"
              @change="$router.push($event)"
            />
          </van-dropdown-menu>
        </div>
      </template>
    </van-nav-bar>
    <!-- 基础信息 -->
    <basic-info
      title="累计人口总数"
      :showArea="!areaFromUrl"
      :areaList="areaList"
      :totalCount="totalCount"
      :currentArea="currentArea ? currentArea : '全市'"
      @handleAreaChange="handleAreaChange" />
    <!-- 图表 -->
    <div class="components-container-v2 page-container">
      <!-- 人口分布 -->
      <pie-chart
        :title="countByArea.title"
        :chartData="countByArea.chartData" />
      <!-- 年龄段占比 -->
      <bar-chart-bothway
        :showYearSelect="false"
        :chartData="age.chartData"
        :chartX="age.chartX"
        :title="age.title"
        :legendStyle="{padding:'0 20% 0 30%'}" />
      <!-- 男女比例 -->
      <pie-chart
        :chartData="sex.chartData"
        :chartX="sex.chartX"
        :title="sex.title"
        :color="sex.color"
        :reverse="sex.reverse" />
    </div>
  </div>
</template>

<script>
import {
  NavBar,
  DropdownMenu,
  DropdownItem
} from 'vant'
import BasicInfo from '@/components/analyse/basic-info'
import PieChart from '@/components/chart/pie-chart'
import BarChartBothway from '@/components/chart/bar-chart-bothway'

import { pages, currentYear, areaList, colors } from '@/common/config'
import { generatorData } from '@/common/utils'

export default {
  name: 'Enterprise',
  components: {
    [NavBar.name]: NavBar,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    BasicInfo,
    PieChart,
    BarChartBothway
  },
  data() {
    return {
      colors: colors,
      areaList: [],
      currentArea: '', // 默认城市  安庆市
      areaFromUrl: '', // url拼接地址，查询具体市区，并隐藏地区筛选、企业分布
      totalCount: 0,
      countByArea: {
        chartData: [],
        title: '',
        legendLeft: [],
        legendRight: []
      },
      age: {
        chartData: [],
        chartX: [],
        title: ''
      },
      sex: {
        chartData: [],
        title: '',
        color: [],
        reverse: true
      },
      currentYear: currentYear
    }
  },
  computed: {
    pages() {
      return pages.filter(item => {
        return item.value !== this.$route.path
      })
    }
  },
  mounted() {
    this.getAreaList()
    this.initData()
  },
  methods: {
    initData() {
      this.getCountByArea()
      this.getCount()
      this.getAge()
      this.getSex()
    },
    // 获取区域列表
    async getAreaList() {
      this.areaList = areaList
      this.areaList.unshift('安庆市')
      this.currentArea = '安庆市'
    },
    // 获取总数
    async getCount() {
      this.totalCount = generatorData(10000, 100000, 1)[0]
    },
    // 人口分布
    async getCountByArea() {
      const length = areaList.length
      const arr = generatorData(10000, 100000, length)
      this.countByArea.chartData = arr.map((item, index) => {
        return {
          name: areaList[index],
          value: arr[index]
        }
      })
      this.countByArea.title = '人口分布'
    },
    // 年龄段分布
    async getAge() {
      this.age.chartData = [
        {name: '男性', data: generatorData(10000, 50000, 10)},
        {name: '女性', data: generatorData(10000, 50000, 10)}
      ]
      this.age.chartX = ["0-9岁", "10-19岁", "20-29岁", "30-39岁", "40-49岁", "50-59岁", "60-69岁", "70-79岁", "80-89岁", "90岁及以上"]
      this.age.title = '各年龄段占比'
    },
    // 性别分布
    async getSex() {
      this.sex.chartData = [
        {name: '男性', value: generatorData(10000, 50000, 1)[0]},
        {name: '女性', value: generatorData(10000, 50000, 1)[0]}
      ]
      this.sex.title = '人口性别比例'
    },
    // 选择时间
    handleYearChange({eventName, year}) {
      this[eventName](year)
    },
    // 选择区域
    handleAreaChange(area) {
      this.currentArea = area
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
